export const LIST_NAME = `planEventType`
export const getBasicUrl = planTypeId => `/plans/${planTypeId}/events/types`
